const getGlobalTemplates = state => {
    return state.globalTemplates;
};

export default {
    getGlobalTemplates,
};
